import { type MutationError, trpc } from '@/shared/api';

interface UseMoveExhibitionOptions {
  readonly onSuccess?: () => void;
}

/** 같은 목적 안에서 한 칸 위·아래로 옮긴다. 끝에서 더 못 가면 서버가 아무것도 바꾸지 않는다. */
export const useMoveExhibition = ({ onSuccess }: UseMoveExhibitionOptions = {}) => {
  const mutation = trpc.productManagement.exhibitions.move.useMutation({ onSuccess });
  const error: MutationError | null = mutation.error;

  return {
    moveExhibition: (id: string, direction: 'UP' | 'DOWN') => mutation.mutate({ id, direction }),
    isPending: mutation.isPending,
    error,
    /** 지난 오류를 지운다 — 목록의 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: mutation.reset,
  };
};
